// extracted by mini-css-extract-plugin
export default {"wrapText":"SWxBJQvdqP5FP9yyMPNE","minHeight":"pdVqMhxkxMLF5bfefZtP"};